// useCumulativeCalculation.js or utils/cumulativeCalculation.js
export function runCumulativeCalculation({
  answers,
  fields,
  prevAnswers,
  prevFields,
  handleAnswerChanged,
  getFieldCalculation,
  isPublicFormAnswer
}) {
  if (!Array.isArray(fields) || !getFieldCalculation) return;
  if (!isPublicFormAnswer && prevAnswers === answers && prevFields === fields) return;

  const rowFields = fields?.filter(field => field.type === 'cumulative_calculation');
  const multiGridFields = fields?.filter(e => e.type === 'multi_field');
  const calculationFields = fields?.filter(e => e.type === 'calculation');

  if (rowFields && rowFields.length) {
    rowFields.forEach((rowField) => {
      if (!rowField && !multiGridFields?.length) return;

      const formula = rowField?.meta_data?.form_calculation?.cumulative_calculation;
      if (!formula) return;

      const formulaTokens = formula?.replace(/\s+/g, '')?.split(/([()+\-*/])/)?.filter(arr => arr!=='') || [];

      const hasSameConditionalScope = (field) => {
        const rowConditionalKey = rowField?.conditional_field?.key || rowField?.conditional_field?.id || rowField?.conditional_field;
        const fieldConditionalKey = field?.conditional_field?.key || field?.conditional_field?.id || field?.conditional_field;

        if (!rowConditionalKey) return true;
        if (!fieldConditionalKey) return true;
        if (rowConditionalKey !== fieldConditionalKey) return false;

        const normalizeConditionalValues = (values = []) => (
          values.map(value => value?.value ?? value?.key ?? value).sort()
        );

        const rowConditionalValues = normalizeConditionalValues(rowField?.conditional_values || []);
        const fieldConditionalValues = normalizeConditionalValues(field?.conditional_values || []);

        if (!rowConditionalValues.length || !fieldConditionalValues.length) return true;

        return JSON.stringify(rowConditionalValues) === JSON.stringify(fieldConditionalValues);
      };

      let referencedFields = [...multiGridFields, ...calculationFields].filter((field) => {
        const calcFieldId = field.meta_data?.calc_field_id;
        const calcIds = typeof calcFieldId === 'object'
          ? Object.values(calcFieldId)
          : [calcFieldId];
        const isFormulaMatch = calcIds.some(id => formulaTokens.includes(id)) || formulaTokens.includes(field.id);
        return isFormulaMatch && hasSameConditionalScope(field);
      });

      if (!referencedFields) return;
      const answerObj = {};

      const columnCalcMap = referencedFields.reduce((acc, field) => {
        if (field.multiple_fields) {
          Object.entries(field.multiple_fields).forEach(([key, fieldData]) => {
            if (fieldData.type?.type === 'columncalculation') {
              if (!acc[field.id]) acc[field.id] = {};
              acc[field.id][key] = {
                fieldKey: key,
                title: fieldData.title,
                calculation: fieldData.calculation
              };
            }
          });
        }
        return acc;
      }, {});

      referencedFields.forEach((field) => {
        const calcFieldId = field.meta_data?.calc_field_id;

        if (!calcFieldId) return;

        if (field?.type === 'multi_field') {
          if (typeof calcFieldId === 'object' && !Array.isArray(calcFieldId)) {
            Object.entries(calcFieldId).forEach(([multiKey, mappedCalcId]) => {
              if (!formulaTokens.includes(mappedCalcId)) return;
              const colKey = columnCalcMap[field.id]?.[multiKey]?.fieldKey;
              const sum = (answers[field.id] || []).reduce(
                (acc, row) => acc + (Number(row?.[colKey]) || 0),
                0
              );
              answerObj[mappedCalcId] = sum;
            });
          }
        } else if (typeof calcFieldId === 'string' && formulaTokens.includes(calcFieldId)) {
          answerObj[calcFieldId] = answers[field.id];
        }
      });

      // Final calculation using the parsed formula and built values
      const calculation = getFieldCalculation(formula, answerObj); // THIS FUNCTION WRITTEN RESULT OF THE CALCULATION
      const decimalConfig = rowField?.settings?.validations?.decimal_point;

      const allowedDecimals = typeof decimalConfig?.name === 'number'
        ? decimalConfig.name
        : null;

      let finalValue = calculation;
      if ((typeof finalValue === 'number' && !Number.isFinite(finalValue)) || finalValue === false) {
        finalValue = null;
      }

      if (
        allowedDecimals !== null
        && finalValue !== ''
        && finalValue !== undefined
        && finalValue !== null
        && !Number.isNaN(Number(finalValue))
      ) {
        const valueStr = String(finalValue);

        if (valueStr.includes('.')) {
          const [intPart, decimalPart] = valueStr.split('.');

          finalValue = decimalPart !== undefined
            ? `${intPart}.${decimalPart.slice(0, allowedDecimals)}`
            : intPart;
        }
      }
      if (prevAnswers?.[rowField?.id] !== finalValue) {
        handleAnswerChanged(finalValue, rowField?.id, undefined); // SET TO CUMULATIVE CALCULATION FIELD
      }
    });
  }
}
